const PenguinModal = (function() {
    let modal = null;
    let isOpen = false;

    function init() {
        // Create modal element if it doesn't exist
        if (!document.getElementById('penguin-modal')) {
            createModal();
        }
        modal = document.getElementById('penguin-modal');
        bindEvents();
    }

    function createModal() {
        const modalHTML = `
            <div id="penguin-modal" class="penguin-modal">
                <div class="penguin-modal__overlay" data-modal-close></div>
                <div class="penguin-modal__container">
                    <button class="penguin-modal__close" type="button" data-modal-close aria-label="Close modal">
                        <span>&times;</span>
                    </button>
                    <div class="penguin-modal__content">
                        <!-- Content will be dynamically inserted here -->
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
    }

    function bindEvents() {
        // Close modal events
        document.addEventListener('click', function(e) {
            if (e.target.hasAttribute('data-modal-close') || e.target.closest('[data-modal-close]')) {
                close();
            }
        });

        // Open modal events for data-modal attributes
        document.addEventListener('click', function(e) {
            const modalTrigger = e.target.closest('[data-modal]');
            if (modalTrigger) {
                e.preventDefault();
                const href = modalTrigger.getAttribute('href');
                if (href) {
                    open(href);
                }
            }
        });

        // Escape key to close
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && isOpen) {
                close();
            }
        });

        // Prevent body scroll when modal is open
        modal.addEventListener('transitionend', function(e) {
            if (e.propertyName === 'visibility' && isOpen) {
                document.body.classList.add('modal-open');
            }
        });
    }

    function open(content, options = {}) {
        if (!modal) {
            init();
        }

        const contentElement = modal.querySelector('.penguin-modal__content');
        
        // Show loading state
        modal.classList.add('is-loading');
        modal.style.display = 'flex';
        
        // Force reflow
        modal.offsetHeight;
        
        // Open modal
        modal.classList.add('is-open');
        isOpen = true;

        // Handle different content types
        if (typeof content === 'string') {
            // Check if it's an element selector (starts with #)
            if (content.startsWith('#')) {
                const element = document.querySelector(content);
                if (element) {
                    // Clone the element to avoid moving it from its original location
                    const clonedElement = element.cloneNode(true);
                    
                    // Remove lity-hide class and ensure visibility
                    clonedElement.classList.remove('lity-hide');
                    clonedElement.style.display = '';
                    
                    contentElement.innerHTML = '';
                    contentElement.appendChild(clonedElement);
                    modal.classList.remove('is-loading');
                } else {
                    contentElement.innerHTML = '<p>Content not found</p>';
                    modal.classList.remove('is-loading');
                }
            }
            // Check if it's a URL
            else if (content.startsWith('http') || content.startsWith('/')) {
                loadContentFromUrl(content, contentElement, options);
            } else {
                // Assume it's HTML content
                contentElement.innerHTML = content;
                modal.classList.remove('is-loading');
            }
        } else if (content instanceof HTMLElement) {
            // DOM element
            contentElement.innerHTML = '';
            contentElement.appendChild(content);
            modal.classList.remove('is-loading');
        } else if (content instanceof jQuery) {
            // jQuery element
            contentElement.innerHTML = '';
            contentElement.appendChild(content[0]);
            modal.classList.remove('is-loading');
        }

        // Focus management
        modal.focus();
        
        // Trigger custom event
        document.dispatchEvent(new CustomEvent('penguin-modal:opened', { detail: { content, options } }));
    }

    function loadContentFromUrl(url, contentElement, options) {
        // Check if it's an image
        if (isImageUrl(url)) {
            const img = document.createElement('img');
            img.src = url;
            img.alt = options.alt || 'Modal image';
            img.onload = function() {
                contentElement.innerHTML = '';
                contentElement.appendChild(img);
                modal.classList.remove('is-loading');
            };
            img.onerror = function() {
                contentElement.innerHTML = '<p>Failed to load image</p>';
                modal.classList.remove('is-loading');
            };
        } else if (isVideoUrl(url)) {
            // Handle video URLs (YouTube, Vimeo, etc.)
            const videoEmbed = createVideoEmbed(url);
            contentElement.innerHTML = videoEmbed;
            modal.classList.remove('is-loading');
            // Add video class to container for full width
            modal.querySelector('.penguin-modal__container').classList.add('has-video');
        } else if (url.includes('books.google.com')) {
            // Special handling for Google Books - always load fresh
            const iframe = document.createElement('iframe');
            // Add timestamp to prevent caching issues
            const timestamp = new Date().getTime();
            const separator = url.includes('?') ? '&' : '?';
            iframe.src = url + separator + '_t=' + timestamp;
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.style.width = '100%';
            iframe.style.height = '80vh';
            iframe.onload = function() {
                modal.classList.remove('is-loading');
            };
            iframe.onerror = function() {
                contentElement.innerHTML = '<p>Failed to load Google Books preview</p>';
                modal.classList.remove('is-loading');
            };
            contentElement.innerHTML = '';
            contentElement.appendChild(iframe);
            // Add video class to container for full width (Google Books also benefits from full width)
            modal.querySelector('.penguin-modal__container').classList.add('has-video');
        } else {
            // Assume it's an iframe (other content)
            const iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.onload = function() {
                modal.classList.remove('is-loading');
            };
            iframe.onerror = function() {
                contentElement.innerHTML = '<p>Failed to load content</p>';
                modal.classList.remove('is-loading');
            };
            contentElement.innerHTML = '';
            contentElement.appendChild(iframe);
        }
    }

    function isImageUrl(url) {
        const imageExtensions = /\.(jpg|jpeg|png|gif|webp|svg|bmp|ico|tiff?)(\?\S*)?$/i;
        return imageExtensions.test(url) || url.startsWith('data:image/');
    }

    function isVideoUrl(url) {
        const videoPatterns = [
            /youtube\.com\/watch\?v=/,
            /youtu\.be\//,
            /vimeo\.com\//,
            /\.(mp4|webm|ogg|mov)(\?\S*)?$/i
        ];
        return videoPatterns.some(pattern => pattern.test(url));
    }

    function createVideoEmbed(url) {
        // YouTube
        if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
            const videoId = extractYouTubeId(url);
            return `<iframe width="100%" height="80vh" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
        // Vimeo
        else if (url.includes('vimeo.com/')) {
            const videoId = url.match(/vimeo\.com\/(\d+)/)?.[1];
            if (videoId) {
                return `<iframe width="100%" height="80vh" src="https://player.vimeo.com/video/${videoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
            }
        }
        // Direct video file
        else {
            return `<video controls autoplay style="width: 100%; height: auto;"><source src="${url}" type="video/mp4">Your browser does not support the video tag.</video>`;
        }
        return '<p>Unsupported video format</p>';
    }

    function extractYouTubeId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    }

    function close() {
        if (!modal || !isOpen) return;

        modal.classList.remove('is-open');
        isOpen = false;
        document.body.classList.remove('modal-open');

        // Clean up after animation
        setTimeout(() => {
            modal.style.display = 'none';
            const contentElement = modal.querySelector('.penguin-modal__content');
            const container = modal.querySelector('.penguin-modal__container');
            
            // Clear content and remove any iframes to prevent reload issues
            contentElement.innerHTML = '';
            
            // Remove any existing iframes to ensure clean state
            const iframes = contentElement.querySelectorAll('iframe');
            iframes.forEach(iframe => {
                iframe.remove();
            });
            
            // Remove video class
            container.classList.remove('has-video');
        }, 300);

        // Trigger custom event
        document.dispatchEvent(new CustomEvent('penguin-modal:closed'));
    }

    function resize() {
        if (modal && isOpen) {
            // Trigger resize event for iframe content if needed
            const iframe = modal.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage('resize', '*');
            }
        }
    }

    // Public API
    return {
        init,
        open,
        close,
        resize,
        isOpen: () => isOpen
    };
})();

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    PenguinModal.init();
});

// Global function for backward compatibility (similar to lity)
window.penguinModal = function(content, options) {
    return PenguinModal.open(content, options);
};

// Export a function that initializes the modal
function init() {
    PenguinModal.init();
}

export default init;
